// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1tcW2","errorLogs":"EditorFooter_errorLogs__399xU"};